/** Kleine Helfer der Koerperkarte (F-34 C3) - getrennt, damit die Komponenten-Dateien nur Komponenten exportieren. */
import { useEffect, useState } from 'react';

import { MUSKELN, type GruppeId, type MuskelId } from '@/domain/training/muskeln';
import { formatDe, toLocalDateTime } from '@/lib/datetime';

export const gruppenMuskeln = (g: GruppeId): MuskelId[] => (Object.keys(MUSKELN) as MuskelId[]).filter((m) => MUSKELN[m].gruppe === g);

export const erholtAbText = (ms: number | null) => {
  if (!ms) return 'erholt';
  return `voraussichtlich erholt ab ${formatDe(toLocalDateTime(new Date(ms)), 'EEEEEE HH:mm')} Uhr`;
};

/** Aktuelle Zeit in ms, jede Minute neu - fuer Schaetzungen, die mit der Zeit fortschreiten. */
export function useJetzt(takt = 60_000): number {
  const [jetzt, setJetzt] = useState(() => Date.now());
  useEffect(() => {
    const t = setInterval(() => setJetzt(Date.now()), takt);
    return () => clearInterval(t);
  }, [takt]);
  return jetzt;
}
